import React, { useImperativeHandle, useCallback, useState } from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { FeedbackQuestionHandler, FeedbackSectionInfo } from '../utils';
import {
  LengthCounter,
  MAX_CHARACTER_DESCRIPTION,
  MIN_CHARACTER_DESCRIPTION,
  TextArea,
} from '../../../ReportBuilder/Components/SectionLongText';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';

const ACTIVITY_QUESTION_ID = 110050;

const StyledDiv = styled.div`
  .text-area {
    display: block;
    margin-left: auto;
    margin-right: auto;
    max-width: 600px;
    margin-top: ${SPACERS.medium};
    .text-field {
      margin-bottom: ${SPACERS.tiny};
      background-color: ${COLORS.whiteBase} !important;
    }
  }
`;

const Description = React.forwardRef<
  FeedbackQuestionHandler,
  FeedbackSectionInfo
>(({ reportId, questionId, questionText, answer }, forwardRef) => {
  const [text, setText] = useState<string>(answer || '');

  const handleText = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setText(e.target.value);
    },
    [setText],
  );

  useImperativeHandle(forwardRef, () => ({
    reportId,
    questionId,
    answer: () => text,
    errorText: () => {
      if (questionId === ACTIVITY_QUESTION_ID && text.length === 0) {
        return undefined;
      }
      return text.length < MIN_CHARACTER_DESCRIPTION ||
        text.length > MAX_CHARACTER_DESCRIPTION
        ? `Description must be between ${MIN_CHARACTER_DESCRIPTION} and ${MAX_CHARACTER_DESCRIPTION}.`
        : undefined;
    },
  }));

  return (
    <StyledDiv>
      <TrueImpactText variant="heading-subheading" className="question-text">
        {questionText}
      </TrueImpactText>
      <div className="text-area">
        <TextArea value={text} onChange={handleText} className="text-field" />
        <LengthCounter length={text.length} />
      </div>
    </StyledDiv>
  );
});

export default Description;
